import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: "",
  isLogin: false,
  isSetupCompleted: false,
  isSuperUser: false,
  communityId: "",
  communityName: "",
  communityCode: "",
  communityCreatedDate: "",
  user: "",
  roleId: null,
  roleName: null,
  menu: [],
  communitiesList: [],
  pendingCommunityList: null,
  isSkip: false,
  lastActiveCommunity: null,
  isWaitListVerified: false,
  waitListCount: 0,
  selectedAction: null,
  onboardingStep: 0,
  notiFlag: false,
  userDetailId: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    otpReducer: (state, action) => {
      state.accessToken = action.payload.accessToken;
    },
    login: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.user = { userName: action.payload.userFullName, email: action.payload.emailAddress };
      state.isLogin = true;
      state.userDetailId = action.payload?.userDetailId
    },
    activeCommunity: (state, action) => {
      // debugger;
      state.menu = action.payload?.menu;
      state.isSetupCompleted = action.payload?.isSetupCompleted;
      state.isSuperUser = action.payload?.isSuperUser;
      state.communityId = action.payload?.communityId;
      state.communityCode = action.payload?.communityCode;
      state.communityName = action.payload?.communityName;
      state.communityCreatedDate = action.payload?.createdDate;
      state.userType = action.payload?.userType;
      state.roleId = action.payload?.roleId;
      state.roleName = action.payload?.roleName;

    },


    setCommunityId: (state, action) => {
      state.communityId = action.payload;
    },
    setLogin: (state, action) => {

      state.isLogin = action.payload;

    },

    setIsSetupCompleted: (state, action) => {
      state.isSetupCompleted = action.payload;
    },
    setCommunitiesList: (state, action) => {
      state.communitiesList = action.payload;
    },
    setPendingCommunityList: (state, action) => {
      state.pendingCommunityList = action.payload;
    },
    setLastActiveCommunity: (state, action) => {
      state.lastActiveCommunity = action.payload;
    },
    setIsSkip: (state, action) => {
      state.isSkip = action.payload;
    },
    setIsWaitListVerified: (state, action) => {
      state.isWaitListVerified = action.payload;
    },
    setWaitListData: (state, action) => {
      state.totalWaitListUsers = action.payload?.totalWaitListUsers;
      state.waitListPosition = action.payload?.waitListPosition;
    },
    setSelectedAction: (state, action) => {
      state.selectedAction = action.payload;
    },
    setOnboardingStep: (state, action) => {
      state.onboardingStep = action.payload;
    },
    // login: (state, action) => {
    //   state.accessToken = action.payload.accessToken;
    //   state.user = action.payload.user;
    //   state.isLogin = true;
    //   state.communitiesList = action.payload.communityDetail;
    //   // state.menu = action.payload.communityDetail?.menu;
    //   // state.isCommunity = action.payload.communityDetail?.isSetupCompleted
    //   //   ? 1
    //   //   : state.isCommunity;
    //   // state.isSuperUser = action.payload.communityDetail?.isSuperUser;
    //   // state.communityId = action.payload.communityDetail?.communityId;
    //   // state.communityName = action.payload.communityDetail?.communityName;
    // },
    // // signup: (state, action) => {
    // //   state.accessToken = action.payload.accessToken;
    // //   state.isCommunity = 0;
    // //   state.user = action.payload.user;
    // //   state.isLogin = true;
    // // },
    // completeSetup: (state, action) => {
    //   state.isCommunity = action.payload;
    // },
    // createCommunity: (state, action) => {
    //   state.communityId = action.payload.communityId;
    //   state.communityName = action.payload.communityName;
    // },
    // setAmmenityList: (state, action) => {
    //   state.communityAmmenityList = action.payload;
    // },
    // communityDetails: (state, action) => {
    //   state.menu = action.payload?.menu;
    //   state.isCommunity =
    //     action.payload?.communityId === 18
    //       ? 2
    //       : action.payload?.isSetupCompleted
    //       ? 1
    //       : 0;
    //   state.isSuperUser = action.payload?.isSuperUser;
    //   state.communityId = action.payload?.communityId;
    //   state.communityName =
    //     action.payload?.communityId === 18 ? "" : action.payload?.communityName;
    //   state.roleId = action.payload?.roleId;
    // },
    logout: (state) => {
      state.accessToken = "";
      state.isLogin = false;
      state.user = "";
      state.isSuperUser = false;
      state.isSetupCompleted = false;
      state.communityId = "";
      state.communityName = "";
      state.communityCode = "";
      state.communityCreatedDate = "";
      state.menu = [];
      state.communitiesList = [];
      state.pendingCommunityList = null;
      state.isSkip = false;
      state.roleId = null;
      state.roleName = null;
      state.lastActiveCommunity = null;
      state.isWaitListVerified = false;
      state.totalWaitListUsers = 0;
      state.waitListPosition = 0;
      state.selectedAction = null;
      state.onboardingStep = 0;
      state.deviceToken = null;
      state.notiFlag = false;
      state.userDetailId = null;

      // state.communityAmmenityList = [];
    },

    setNotiFlag: (state, action) => {
      state.notiFlag = action.payload;
    },
    setAttemptWaitList: (state, action) => {
      state.attempt = action.payload?.attempt;

    }
  },
});

export const {
  login,
  logout,
  otpReducer,
  activeCommunity,
  setCommunitiesList,
  setPendingCommunityList,
  setIsSkip,
  setLastActiveCommunity,
  setIsWaitListVerified,
  setWaitListData,
  setSelectedAction,
  setOnboardingStep,
  setIsSetupCompleted,
  setLogin
  ,
  setCommunityId,
  setAttemptWaitList,

  setNotiFlag
} = authSlice.actions;
export default authSlice.reducer;
